import { publicRoutes } from "./routes/publicRoutes";
import { accountRoutes } from "./routes/accountRoutes";
import { inventoryRoutes } from "./routes/inventoryRoutes";
import { hrRoutes } from "./routes/hrRoutes";
import { crmRoutes } from "./routes/crmRoutes";
import { propertyRoutes } from "./routes/propertyRoutes";
import { registryRoutes } from "./routes/registryRoutes";
import { assetRoutes } from "./routes/assetRoutes";
import { userRoutes } from "./routes/userRoutes";
import { settingsRoutes } from "./routes/settingsRoutes";
import { storeRoutes } from "./routes/storeRoutes";
import { procurementRoutes } from "./routes/procurementRoutes";
import { worksRoutes } from "./routes/worksRoutes";
import { clientWorkRoutes } from "./routes/clientWorkRoutes";
import { salesRoutes } from "./routes/salesRoutes";
import { commissionRoutes } from "./routes/commissionRoutes";

export const AdminRoutes = [
  ...publicRoutes,
  ...accountRoutes,
  ...commissionRoutes,
  ...salesRoutes,
  ...inventoryRoutes,
  ...hrRoutes,
  ...crmRoutes,
  ...propertyRoutes,
  ...registryRoutes,
  ...assetRoutes,
  ...userRoutes,
  ...settingsRoutes,
  ...storeRoutes,
  ...procurementRoutes,
  ...worksRoutes,
  ...clientWorkRoutes,
];
